import React, { useContext, useState, useEffect } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import { AppContext } from '../../contexts/AppContext';
import {translate} from '../../helpers/base';
const PriceRange = ({ onChange }) => {

    const { selectedFilters, setSelectedFilters, filteredResultsWithoutPriceFilter } = useContext(AppContext);
    const [selectedMinPrice, setSelectedMinPrice] = useState(0);
    const [selectedMaxPrice, setSelectedMaxPrice] = useState(0);
    const [maxPrice, setMaxPrice] = useState(0);

    const getMaxPrice = (roundToNext = 10) => {
        const maxPrice = filteredResultsWithoutPriceFilter.reduce((maxPrice, item) => Math.max(maxPrice, item.price), 0);
        return Math.ceil(maxPrice / roundToNext) * roundToNext;
    }

    useEffect(() => {
        if(!selectedFilters.price) {
            setSelectedMinPrice(0);
            setSelectedMaxPrice(maxPrice);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedFilters.price, maxPrice]);

    useEffect(() => {
        if(selectedFilters.price) {
            const [filterMinPrice, filterMaxPrice] = selectedFilters.price.split('-').map(Number);
            setSelectedMinPrice(filterMinPrice);
            setSelectedMaxPrice(filterMaxPrice);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useDeepCompareEffect(() => {
        const maxPrice = getMaxPrice();
        if(!maxPrice) {
            return;
        }
        setMaxPrice(maxPrice);
        if(selectedFilters.price) {
            const [filterMinPrice, filterMaxPrice] = selectedFilters.price.split('-').map(Number);
            if(filterMinPrice > maxPrice && filterMaxPrice < maxPrice) {
                setSelectedMinPrice(0);
                setSelectedFilters(prev => ({...prev, price: '0-' + filterMaxPrice}));
            } else if(filterMinPrice > maxPrice && filterMaxPrice > maxPrice) {
                setSelectedMinPrice(0);
                setSelectedMaxPrice(maxPrice);
                setSelectedFilters(prev => ({...prev, price: undefined}));
            } else if (filterMaxPrice > maxPrice) {
                setSelectedFilters(prev => ({...prev, price: undefined}));
                setSelectedMaxPrice(maxPrice);
            }
        }
    }, [filteredResultsWithoutPriceFilter]);

    const updatePrices = (newSelectedMinPrice, newSelectedMaxPrice) => {
        setSelectedMinPrice(newSelectedMinPrice);
        setSelectedMaxPrice(newSelectedMaxPrice);
    };

    const handleSliderChange = (values) => {
        updatePrices(values[0], values[1]);
    };

    const handleDragEnd = () => {
        onChange(selectedMinPrice, selectedMaxPrice);
    };

    const handleMinInputChange = (e) => {
        const value = Number(e.target.value);
        updatePrices(value, selectedMaxPrice);
    };

    const handleMaxInputChange = (e) => {
        const value = Number(e.target.value);
        updatePrices(selectedMinPrice, value);
    };
    const handleMinInputBlur = () => {
        const roundedValue = Math.round(selectedMinPrice / 10) * 10;
        const minPrice = Math.min(Math.max(0, roundedValue), selectedMaxPrice);
        updatePrices(minPrice, selectedMaxPrice);
        onChange(minPrice, selectedMaxPrice);
    };

    const handleMaxInputBlur = () => {
        const roundedValue = Math.round(selectedMaxPrice / 10) * 10;
        const newMaxPrice = Math.max(Math.min(maxPrice, roundedValue), selectedMinPrice);
        updatePrices(selectedMinPrice, newMaxPrice);
        onChange(selectedMinPrice, newMaxPrice);
    };

    return (
        <>
            <div className="h5">{translate('accommodation-overview.filter.priceRange.label')}</div>
            <RangeSlider
                value={[selectedMinPrice, selectedMaxPrice]}
                onInput={handleSliderChange}
                onThumbDragEnd={handleDragEnd}
                min={0}
                max={maxPrice}
                step={10}
            />
            <div className="form-group-price">
                <div className="form-group">
                    <label>{translate('accommodation-overview.filter.priceRange.min')}</label>
                    <input
                        type="text"
                        className="range-slider-min"
                        value={selectedMinPrice}
                        onChange={handleMinInputChange}
                        onBlur={handleMinInputBlur}
                    />
                </div>
                <span></span>
                <div className="form-group">
                    <label>{translate('accommodation-overview.filter.priceRange.max')}</label>
                    <input
                        type="text"
                        className="range-slider-max"
                        value={selectedMaxPrice}
                        onChange={handleMaxInputChange}
                        onBlur={handleMaxInputBlur}
                    />
                </div>
            </div>
        </>
    );
};

export default PriceRange;
